"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var dashboardContexts_1 = require("../dashboardContexts");
/**
 * @internal
 */
exports.ShareDialog = function (props) {
    var ShareDialogComponent = dashboardContexts_1.useDashboardComponentsContext().ShareDialogComponent;
    return react_1.default.createElement(ShareDialogComponent, tslib_1.__assign({}, props));
};
//# sourceMappingURL=ShareDialog.js.map